import { render } from "./TournamentTable.vue?vue&type=template&id=2f6fbfe4&scoped=true"
import script from "./TournamentTable.vue?vue&type=script&lang=js"
export * from "./TournamentTable.vue?vue&type=script&lang=js"

import "./TournamentTable.vue?vue&type=style&index=0&id=2f6fbfe4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6fbfe4"]])

export default __exports__